export default {
  data: () => ({

    canvasForms:  null,

    rawData:  [],
    

    title: null,
    bar: null,
    values: null,
    columns: null,


    keys: null,
    filters: null,
    sundries: null,
  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}